import { useEffect } from 'react';

export function buildCommunityInviteAcceptPath(inviteToken: string): string {
  return `/community-invite/${encodeURIComponent(inviteToken)}`;
}

export function readCommunityInviteTokenFromPath(pathname: string): string {
  const prefix = "/community-invite/";
  if (!pathname.startsWith(prefix)) return "";

  const rawToken = pathname.slice(prefix.length).replace(/\/+$/, "");
  if (!rawToken) return "";

  try {
    return decodeURIComponent(rawToken);
  } catch {
    return "";
  }
}

/**
 * Redirects legacy inviteToken query links to the explicit invite acceptance page.
 */
export function useHandleInviteToken(_options?: { onAuthRequired?: () => void }) {
  useEffect(() => {
    if (typeof window === 'undefined') return;

    const params = new URLSearchParams(window.location.search);
    const token = params.get('inviteToken');
    if (!token) return;

    params.delete('inviteToken');
    const nextSearch = params.toString();
    const preserved = `${nextSearch ? `?${nextSearch}` : ''}${window.location.hash}`;
    window.location.replace(`${buildCommunityInviteAcceptPath(token)}${preserved}`);
  }, []);
}
